$(function() {
	
	function initTimeInputs() {
		$("input.time-input").each(function() {
			$(this).inputmask({
				alias: "datetime",
				inputFormat: ebusy.localTimeInputmaskFormat,
				placeholder: ebusy.localTimeInputmaskPlaceholder
			});
		});
	}
	
	function initDateInputs() {
		$("input.date-input").each(function() {
			$(this).inputmask({
				alias: "datetime",
				inputFormat: ebusy.localeDateInputmaskFormat,
				placeholder: ebusy.localeDateInputmaskPlaceholder
			});
		});
	}

	function initCodeInputs() {
		$("input.code-input").each(function() {
			$(this).inputmask({
				mask: "99999",
				placeholder: ""
			});
		});
	}
	
	$(document).on("form.init modal.load", function() {
		initTimeInputs();
		initDateInputs();
		initCodeInputs();
	});

	initTimeInputs();
	initDateInputs();
	initCodeInputs();
	
});
